import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext, forwardRef } from 'react';
import { HeadingLevelContext } from '../context';
const HeadingLevelBoundary = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { tag, children } = _param, rest = _object_without_properties(_param, [
        "tag",
        "children"
    ]);
    const headingLevel = useContext(HeadingLevelContext);
    const Tag = tag;
    return Tag ? /*#__PURE__*/ React.createElement(HeadingLevelContext.Provider, {
        value: headingLevel + 1
    }, /*#__PURE__*/ React.createElement(Tag, _object_spread_props(_object_spread({}, rest), {
        ref: ref
    }), children)) : /*#__PURE__*/ React.createElement(HeadingLevelContext.Provider, {
        value: headingLevel + 1
    }, children);
});
HeadingLevelBoundary.displayName = 'HeadingLevelBoundary';
export default HeadingLevelBoundary;

//# sourceMappingURL=HeadingLevelBoundary.js.map